<template>
  <div>
    <v-dialog
      v-model="InfoOverlay"
      content-class="overlay-con"
      :persistent="true"
      overlay-opacity="0.8"
    >
   
      <div class="Info-card">
        <div class="icon">
            <v-icon @click="handleClose">mdi-close-circle</v-icon>
               
          </div>
        <div class="first-row" style="">
            
          <div style="padding-left: 134px; width: 326px">
            <h3 style="margin-top: 16px">Metric </h3>
          
          </div>
          <hr style="width: 0.5px; height: 599px" />
          <div style="width: 460px; padding-left: 129px">
            
            <h3 style="margin-top: 16px">Metric Formulae/ Source</h3>
           
          </div>
        </div>
        <hr />
        <div class="definiton-card">
            <div class="second-row" style="">
                <div style="padding-left: 32px; width: 326px; text-align: left">
                  <h3 style="margin-top: 16px">Campaign Metric:</h3>
                  <p style="margin-top: 12px">
                    Campaign metric is calculated depending on the objective of the
                    campaign
                  </p>
                </div>
                
                <div style="width: 460px; padding-left: 30px; padding-top: 20px">
                  <ul>
                    <li>
                      Awareness: Distinct Impressions <br />
                      <small>(Source:Snowflake)</small>
                    </li>
                    <li>
                        App Install: Distinct Clicks * Conversion Rate <br />
                      <small>(Source:Snowflake)</small>
                    </li>
                    <li>
                        Lead Generation: Form Fills <br />
                      <small>(Source:RDS)</small>
                    </li>
                    <li>
                        Farmer Discovery: Form Fills<br />
                      <small>(Source:RDS)</small>
                    </li>
                    <li>
                        CTC: Distinct Clicks<br />
                      <small>(Source:Snowflake)</small>
                    </li>
                    <li>
                        CTW: Distinct Clicks <br />
                      <small>(Source:Snowflake)</small>
                    </li>
                    <li>
                        Product Sale: Order with status PLACED <br />
                      <small>(Source:RDS)</small>
                    </li>
                    <li>
                        Redirection: Distinct Clicks <br />
                      <small>(Source:Snowflake)</small>
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
      
              <div class="third-row">
                <div style="padding-left: 32px; width: 326px">
                  <h3 style="margin-top: 16px">Campaign Progress:</h3>
                  <p style="margin-top: 12px">
                    Campaign progress as per the current date.
                  </p>
                </div>
      
                <div style="width: 460px; padding-left: 32px; padding-top: 45px">
                  <p>Campaign Metric / Target</p>
                </div>
              </div>
              <hr />
              <div class="fourth-row" style="">
                <div style="padding-left: 32px; width: 326px">
                  <h3 style="margin-top: 16px; margin-bottom: 12px">
                    Target Prediction:
                  </h3>
                  <p>
                    At the end of the campaign what would be the percentage of the
                    campaign progress
                  </p>
                </div>
      
                <div style="width: 460px; padding-left: 32px; padding-top: 45px">
                  <p style="margin-top: 12px">((((Current Metric) / current days_passed) * total_days) / Required_metric)* 100</p>
                </div>
              </div>
              <hr />
              <div class="rest-rows">
                <div style="padding-left: 32px; width: 326px">
                  <h3 style="margin-top: 16px">Revenue Achieved:</h3>
                </div>
      
                <div style="width: 460px; padding-left: 32px">
                  <p style="margin-top: 16px">Campaign metric * CPA</p>
                </div>
              </div>
              <hr />
              <div class="rest-rows">
                <div style="padding-left: 32px; width: 326px">
                  <h3 style="margin-top: 16px">CTR:</h3>
                </div>
      
                <div style="width: 460px; padding-left: 32px">
                  <p style="margin-top: 16px">
                    Unique Click / Unique Impressions (3s)
                  </p>
                </div>
              </div>
              <hr />
              <div class="rest-rows">
                <div style="padding-left: 32px; width: 326px">
                  <h3 style="margin-top: 16px">Target:</h3>
                </div>
      
                <div style="width: 460px; padding-left: 32px">
                  <p style="margin-top: 16px;margin-bottom:16px">Expected Revenue / CTA</p>
                </div>
              </div>
            </div>
            <div>
               
            </div>
        </div>
        
        
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "info",
  data() {
    return {
        // InfoOverlay: false,
    };
  },
  props: {
    InfoOverlay : Boolean,

  },
  methods: {
    handleClose() {
        this.$emit("closeInfoCard");
    }
  }

};
</script>

<style lang="scss" scoped>
.Info-card {
  display: flex;
  flex-direction: column;
  width: 780px;
  height: 630px;
  
  
 
}

.v-icon{
    left: 750px;
   
}
.definiton-card{
    overflow-x: hidden;
    overflow-y: scroll;
}
.first-row {
  height: 56px;
  width: 780px;
  display: flex;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}
.second-row {
  height: 410px;
  width: 780px;
  display: flex;
}
.third-row {
  height: 110px;
  width: 780px;
  display: flex;
}
.fourth-row {
  height: 140px;
  width: 780px;
  display: flex;
}
.rest-rows {
  height: 56px;
  width: 780px;
  display: flex;
}
</style>

<style>
.overlay-con.v-dialog {
  width: 780px;
  height: 630px;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: none;
}
</style>